import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/copy-feature-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Copy Feature</title>
        <meta
          name='description'
          content='Save time in creating a new listing from your existing Poshmark listings and boost your sales. Learn here how to you can utilize the Poshmark Copy feature!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/copy-feature-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/copy-feature-poshmark' />
        <meta property='og:title' content='Poshmark Copy Feature' />
        <meta
          property='og:description'
          content='Save time in creating a new listing from your existing Poshmark listings and boost your sales. Learn here how to you can utilize the Poshmark Copy feature!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
